/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerGetTokenQueryResponse,
  TelegramChatsUserControllerGetToken401,
} from '../types/TelegramChatsUserControllerGetToken.ts';

function getTelegramChatsUserGetTokenUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/chats/token` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats/token}
 */
export async function telegramChatsUserGetToken(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramChatsUserControllerGetTokenQueryResponse,
    ResponseErrorConfig<TelegramChatsUserControllerGetToken401>,
    unknown
  >({ method: 'GET', url: getTelegramChatsUserGetTokenUrl().url.toString(), ...requestConfig });
  return res.data;
}
